var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.19623 10.4861V7.03857C5.19623 6.48629 5.64394 6.03857 6.19623 6.03857H6.80364C7.35592 6.03857 7.80364 6.48629 7.80364 7.03857V10.8457C7.80364 11.6204 6.96075 12.1009 6.29414 11.7062L5.68674 11.3466C5.3827 11.1665 5.19623 10.8394 5.19623 10.4861Z",
    fill: "#A1A3B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.59548 1.66518L4.87261 6.88273C5.05558 7.17403 5.37543 7.35084 5.71943 7.35084H7.28051C7.62451 7.35084 7.94436 7.17403 8.12732 6.88273L11.4045 1.66519C11.8228 0.999219 11.3441 0.133301 10.5576 0.133301H2.44229C1.65586 0.133301 1.17718 0.999218 1.59548 1.66518Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter_icon.e1575926fdacfec5d72f7dd60fc0d857.svg";
export { ForwardRef as ReactComponent };